import React from "react";
import EzugiGameInfoImage from "../../../assets/images/casino/popup_images/ezugi_game_info.webp";
import EzugiGameInfoIndigoImage from "../../../assets/images/casino/popup_images/ezugi_game_info_indigo.webp";
import { HOUSE_NAME } from "../../../constants/Branding";

type EzugiGameInfoPopupProps = {
  open: boolean;
  onContinue: () => void;
  onClose: () => void;
};

// Transparent hotspots laid over the buttons drawn in the image
const hotspotStyle: React.CSSProperties = {
  position: "absolute",
  top: "70%",
  height: "17.5%",
  padding: 0,
  border: 0,
  borderRadius: 10,
  background: "transparent",
  cursor: "pointer",
};

// Per-skin image, with hotspot positions (in %) for the buttons drawn in it
const gameInfoSkin =
  HOUSE_NAME == "indigo"
    ? {
        image: EzugiGameInfoIndigoImage,
        continueBtn: { left: "15.1%", width: "33.8%" },
        closeBtn: { left: "51%", width: "33.8%" },
      }
    : {
        image: EzugiGameInfoImage,
        continueBtn: { left: "14.7%", width: "34.6%" },
        closeBtn: { left: "51.5%", width: "34.1%" },
      };

const EzugiGameInfoPopup: React.FC<EzugiGameInfoPopupProps> = ({
  open,
  onContinue,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        background: "rgba(0, 0, 0, 0.7)",
      }}
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Game Info"
        style={{ position: "relative", width: "100%", maxWidth: 720 }}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={gameInfoSkin.image}
          alt="1 Casino Point is equal to 100 Normal Points. Ex: 10 Casino Points = 1000 Points"
          style={{
            display: "block",
            width: "100%",
            height: "auto",
            borderRadius: 12,
          }}
        />
        <button
          type="button"
          aria-label="Continue"
          style={{ ...hotspotStyle, ...gameInfoSkin.continueBtn }}
          onClick={onContinue}
        />
        <button
          type="button"
          aria-label="Close"
          style={{ ...hotspotStyle, ...gameInfoSkin.closeBtn }}
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default EzugiGameInfoPopup;
